import React from 'react';

const PoliceIcon: React.FC<{ size?: number; color?: string }> = ({ size = 14, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M10 3L16 5.5V9.5C16 13.3 13.6 16.4 10 17.5C6.4 16.4 4 13.3 4 9.5V5.5L10 3Z" stroke={color} strokeWidth="1.8" strokeLinejoin="round" />
    <path d="M7 8.8L8.7 10.5L13 7.5" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default PoliceIcon;

